export const readError = async (err) => {
  //console.log("Error object:", err);

  if (err instanceof Response) {
    try {
      const errorText = await err.text(); // Read the response body as text
      //console.log("Error response body:", errorText);

      let errorMessage = errorText;
      try {
        // Try parsing JSON if the response body is JSON-formatted
        const errorJson = JSON.parse(errorText);
        errorMessage = errorJson.error || errorText; // Use the 'error' field if available
      } catch (parseError) {
        console.warn("Failed to parse error body as JSON, using raw text.");
      }

      return errorMessage; // Return the parsed or raw error message
    } catch (readError) {
      //console.error("Failed to read response body:", readError);
      return "Failed to read response body"; // Fallback error message
    }
  } else {
    //console.log("Provided error is not a Response object.");
    return "An unknown error occurred"; // General fallback
  }
};